import {
    Empty, Form,
    Spin,
} from 'antd';
import {CheckboxChangeEvent} from 'antd/es/checkbox';
import {FormInstance} from 'antd/es/form';
import cn from 'classnames';
import React, {Dispatch, SetStateAction} from 'react';

import {TTableAttributesCustomSelectEntry} from '../../../report-table-settings';
import {GROUPING_SETTINGS_PREFIX} from '../dd-grouping-settings-modal-opener-constants';
import {DDGroupingSettingsModalFormActionButtons} from './dd-grouping-settings-modal-form-action-buttons';
import {DDGroupingSettingsModalFormRow} from './dd-grouping-settings-modal-form-row';

interface IDDGroupingSettingsModalFormProps {
  form: FormInstance<any>;
  attributesEntries: TTableAttributesCustomSelectEntry[];
  extendedAttributesEntries: TTableAttributesCustomSelectEntry[] | undefined;
  templateCode: string | null;
  checkedFields: number[];
  usingGroup: boolean;
  groupAfterUserFilterValue: boolean;
  isAttributesLoaded: boolean;
  setCheckedFields: Dispatch<SetStateAction<number[]>>;
  setUsingGroup: Dispatch<SetStateAction<boolean>>;
  setGroupAfterUserFilterValue: Dispatch<SetStateAction<boolean>>;
  handleCheck: (e: CheckboxChangeEvent) => void;
  handleFinish: (values: any) => Promise<void>;
}

export const DDGroupingSettingsModalForm = ({
    form,
    attributesEntries,
    extendedAttributesEntries,
    templateCode,
    checkedFields,
    usingGroup,
    groupAfterUserFilterValue,
    isAttributesLoaded,
    setCheckedFields,
    setUsingGroup,
    setGroupAfterUserFilterValue,
    handleCheck,
    handleFinish,
}: IDDGroupingSettingsModalFormProps) => (
    <div className={cn('dd-grouping-settings-modal-opener')}>
        <Spin
            spinning={!isAttributesLoaded}
        >
            <Form
                onFinish={handleFinish}
                form={form}
                layout="vertical"
                className={cn('dd-grouping-settings-modal-opener__form')}
            >
                {isAttributesLoaded ? (
                    <Form.List
                        name={GROUPING_SETTINGS_PREFIX}
                    >
                        {(fields, {add, remove}, {errors}) => (
                            <>
                                <Form.ErrorList errors={errors} />
                                <DDGroupingSettingsModalFormActionButtons
                                    add={add}
                                    remove={remove}
                                    setCheckedFields={setCheckedFields}
                                    checkedFields={checkedFields}
                                    attributesEntries={attributesEntries}
                                    fields={fields}
                                    usingGroup={usingGroup}
                                    setUsingGroup={setUsingGroup}
                                    groupAfterUserFilterValue={groupAfterUserFilterValue}
                                    setGroupAfterUserFilterValue={setGroupAfterUserFilterValue}
                                />

                                {(() => {
                                    if (isAttributesLoaded && !attributesEntries?.length) {
                                        return (
                                            <Empty
                                                description={
                                                    'Атрибуты источника данных '
                                                + 'табличной части не найдены'
                                                }
                                            />
                                        );
                                    }
                                    if (!fields?.length) return <Empty description="Данные отсутствуют" />;
                                    return null;
                                })}

                                <DDGroupingSettingsModalFormRow
                                    form={form}
                                    fields={fields}
                                    attributesEntries={attributesEntries}
                                    extendedAttributesEntries={extendedAttributesEntries}
                                    templateCode={templateCode}
                                    handleCheck={handleCheck}
                                />
                            </>
                        )}
                    </Form.List>
                ) : <Empty description="Загрузка..." />}
            </Form>
        </Spin>
    </div>
);
